export const genSphereNavLinks = [
    { href: "#banner", label: "Majestic Gen Sphere" },
    { href: "#project-highlights-section", label: "Highlights" },
    { href: "#intro", label: "About" },
    { href: "#floor-plan-section", label: "Layouts" },
    { href: "#map-section", label: "Location" },
    { href: "#application-form-section", label: "Private Viewing" }
]